module.exports = __webpack_public_path__ + "static/media/yellow-s-10.d5e7d0fd.png";